import * as React from 'react';
import {
    ArrayField,
    Datagrid,
    DateField,
    FunctionField,
    Show,
    SimpleShowLayout,
    TextField,
    useShowContext,
} from 'react-admin';
import { getInvoiceTransactionStatusName } from '../enum-translates';
import { WrappedWithBackButton } from '../common/wrapped-with-back-button';
import { Chip } from '@material-ui/core';
import { Stack } from '@mui/material';

const WebUserShowLayout = () => {
    const { error, isLoading } = useShowContext();

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>Error!</div>;
    }
    return (
        <SimpleShowLayout>
            <TextField source="id" label={'ID'} sortable={false} />
            <TextField source="name" label={'Név'} />
            <TextField source="phone" label={'Telefonszám'} />
            <TextField source="email" label={'E-mail'} />
            <DateField
                source="registeredAt"
                locales={['hu-HU']}
                label={'Regisztrálás ideje'}
            />
            <FunctionField
                label="Partner azonosítók"
                render={(record: any) => (
                    <Stack
                        direction={'row'}
                        spacing={1}
                        flexWrap={'wrap'}
                        useFlexGap
                    >
                        {record.partnerIds?.map((partnerId: string) => (
                            <Chip
                                key={partnerId}
                                label={partnerId}
                                size="medium"
                            />
                        ))}
                    </Stack>
                )}
            />
            <FunctionField
                label="Fogyasztási helyek"
                render={(record: any) => (
                    <Stack
                        direction={'row'}
                        spacing={1}
                        flexWrap={'wrap'}
                        useFlexGap
                    >
                        {record.consumerLocations?.map((location: string) => (
                            <Chip
                                key={location}
                                label={location}
                                size="medium"
                            />
                        ))}
                    </Stack>
                )}
            />
            <ArrayField source="payments" label={'Tranzakciók'}>
                <Datagrid bulkActionButtons={false}>
                    <TextField
                        source="transactionCode"
                        label={'Tranzakció kód'}
                    />
                    <FunctionField
                        label="Státusz"
                        render={(record: any) =>
                            `${getInvoiceTransactionStatusName(record.status)}`
                        }
                    />
                    <TextField source="message" label={'Üzenet'} />
                    <DateField
                        source="createdAt"
                        locales={['hu-HU']}
                        label={'Dátum'}
                    />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    );
};

export const WebUserShow = () => {
    return (
        <WrappedWithBackButton>
            <Show title={'Felhasználó'}>
                <WebUserShowLayout />
            </Show>
        </WrappedWithBackButton>
    );
};
